(function () {
  var MARKER = 'data-a11y-external-link';
  var SR_ATTR = 'data-a11y-external-sr';

  var internalHosts = new Set([
    null,
    null
  ].filter(Boolean).map(function (h) { return normalizeHost(h); }));

  function normalizeHost(host) {
    if (!host) return '';
    return String(host).toLowerCase().replace(/^www\./, '');
  }

  function registerInternalHost(host) {
    var normalized = normalizeHost(host);
    if (normalized) internalHosts.add(normalized);
  }

  function getLinkUrl(link) {
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return null;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return null;
    try {
      return new URL(href, window.location.href);
    } catch (e) {
      return null;
    }
  }

  function isExternal(url) {
    var host = normalizeHost(url.hostname);
    if (internalHosts.has(host)) return false;
    return host !== normalizeHost(window.location.hostname);
  }

  function isNewTab(link) {
    return (link.getAttribute('target') || '').toLowerCase() === '_blank';
  }

  function alreadyAnnotated(link) {
    return link.hasAttribute(MARKER) || !!link.querySelector('.sr-only[' + SR_ATTR + ']');
  }

  function labelHints(link) {
    var label = (link.getAttribute('aria-label') || '').toLowerCase();
    return {
      external: label.indexOf('external') !== -1,
      newTab: label.indexOf('opens in a new tab') !== -1 || label.indexOf('opens in new tab') !== -1
    };
  }

  function getMessage(external, newTab, link) {
    var hints = labelHints(link);

    if (external && newTab) {
      if (hints.external && hints.newTab) return null;
      if (!hints.external && !hints.newTab) return '(external site, opens in a new tab)';
      if (!hints.external) return '(external site)';
      if (!hints.newTab) return '(opens in a new tab)';
      return null;
    }
    if (external) {
      if (hints.external) return null;
      return '(external site)';
    }
    if (newTab) {
      if (hints.newTab) return null;
      return '(opens in a new tab)';
    }
    return null;
  }

  function mergeDescribedBy(link, id) {
    var existing = link.getAttribute('aria-describedby');
    if (!existing) return id;
    if (existing.split(/\s+/).indexOf(id) !== -1) return existing;
    return existing + ' ' + id;
  }

  function appendScreenReaderText(link, message) {
    var span = document.createElement('span');
    span.className = 'sr-only';
    span.setAttribute(SR_ATTR, 'true');
    span.textContent = message;

    if (link.hasAttribute('aria-label')) {
      link.setAttribute('aria-label', link.getAttribute('aria-label') + ' ' + message);
      return;
    }

    if (link.hasAttribute('aria-labelledby')) {
      var descId = link.id ? link.id + '-ext-desc' : 'ext-link-desc-' + Math.random().toString(36).slice(2, 9);
      span.id = descId;
      link.setAttribute('aria-describedby', mergeDescribedBy(link, descId));
    }

    link.appendChild(span);
  }

  function annotateLink(link) {
    if (alreadyAnnotated(link)) return;
    if (link.closest('[aria-hidden="true"]')) return;

    var url = getLinkUrl(link);
    if (!url) return;

    var external = isExternal(url);
    var newTab = isNewTab(link);
    var message = getMessage(external, newTab, link);
    if (!message) return;

    link.setAttribute(MARKER, 'true');
    appendScreenReaderText(link, message);
  }

  function normalizeImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('img').forEach(function (img) {
      var role = (img.getAttribute('role') || '').toLowerCase();
      if (role === 'presentation' || role === 'none') {
        img.removeAttribute('role');
      }
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) {
        var link = img.closest('.product-card-url');
        var linkLabel = link ? (link.getAttribute('aria-label') || '').trim() : '';
        if (linkLabel) {
          img.setAttribute('alt', linkLabel);
        }
      }
    });
  }

  function cleanupCarouselAria(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.keen-slider[aria-roledescription]').forEach(function (slider) {
      slider.removeAttribute('aria-roledescription');
    });
  }

  function scanAccessibilityFixes(root) {
    normalizeImages(root);
    cleanupCarouselAria(root);
  }

  var roleObserver;

  function watchImageRoles(img) {
    if (!roleObserver || !img || img.tagName !== 'IMG') return;
    roleObserver.observe(img, { attributes: true, attributeFilter: ['role'] });
  }

  function watchAllImageRoles(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('img').forEach(watchImageRoles);
  }

  function scheduleAccessibilityRescans() {
    [500, 1500, 3000, 6000].forEach(function (delay) {
      window.setTimeout(function () {
        scanAccessibilityFixes(document);
        watchAllImageRoles(document);
      }, delay);
    });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href]').forEach(annotateLink);
    scanAccessibilityFixes(scope);
  }

  function init() {
    registerInternalHost(window.location.hostname);

    roleObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'role') return;
        var img = mutation.target;
        if (!img || img.tagName !== 'IMG') return;
        var role = (img.getAttribute('role') || '').toLowerCase();
        if (role === 'presentation' || role === 'none') {
          img.removeAttribute('role');
        }
      });
    });

    scan(document);
    watchAllImageRoles(document);
    scheduleAccessibilityRescans();

    document.addEventListener('lazyloaded', function (event) {
      if (event.target && event.target.tagName === 'IMG') {
        normalizeImages(event.target.parentElement || document);
        watchImageRoles(event.target);
      }
    }, true);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) annotateLink(node);
          if (node.matches && node.matches('img')) watchImageRoles(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('img').forEach(watchImageRoles);
          }
          scan(node);
        });
      });
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.$s = window.$s || {};
  window.$s.scanAccessibilityFixes = scanAccessibilityFixes;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
